var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"menuActiveIndex":"chart"}},[_c('fish-row',{attrs:{"gutter":"1"}},[_c('fish-col',{attrs:{"span":"12"}},[_c('code-card',{attrs:{"title":"线图","desc":"现状图展示"}},[_c('template',{slot:"demo"},[_c('demo-chart-line')],1)],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cd5f3114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./examples/components/DemoChart.vue
// module id = 857
// module chunks = 1